export type Testimonial = {
  initials: string
  name: string
  role: string
  text: string
}

export const stripTestimonials: Testimonial[] = [
  {
    initials: 'RM',
    name: 'R.M.',
    role: 'BJJ Instructor — London, UK',
    text: 'I no longer spend my Sunday evenings building class structures from scratch. I open the library, pick the session and walk onto the mat completely prepared. My students feel the difference — and so do I.',
  },
  {
    initials: 'DP',
    name: 'D.P.',
    role: 'BJJ Instructor — Toronto, Canada',
    text: 'The Coaching Cues, Corrections & Common Mistakes guide alone saved me multiple times in my first month. That bonus is worth the full price by itself.',
  },
  {
    initials: 'AK',
    name: 'A.K.',
    role: 'BJJ Instructor — Sydney, Australia',
    text: 'The 200 Drills & Training Games completely changed the way I teach. My classes are more dynamic, my students stay engaged and every session feels intentional from the first drill to the last.',
  },
]

export const extendedTestimonials: Testimonial[] = [
  {
    initials: 'VT',
    name: 'V.T.',
    role: 'BJJ Instructor — New York, USA',
    text: 'The escape and positional control progressions completely transformed my students’ development. Every week genuinely feels like a real step forward — and I’m not the one rushing to decide what that step should be.',
  },
  {
    initials: 'CR',
    name: 'C.R.',
    role: 'BJJ Instructor — Melbourne, Australia',
    text: 'I used to get anxious every time a student from a different level joined the group. Now I open the Adaptation System and I have three versions of every concept ready before anyone walks through the door. That one bonus changed everything.',
  },
  {
    initials: 'DG',
    name: 'D.G.',
    role: 'BJJ Instructor — Toronto, Canada',
    text: 'I go through the key cues before every session and I walk onto the mat knowing exactly what I’m going to say. The Coaching Cues guide is something I use every single week without exception.',
  },
  {
    initials: 'AM',
    name: 'A.M.',
    role: 'BJJ Academy Instructor — London, UK',
    text: 'The Assessment System saved my academy program. I had everything organized — skill evaluations, progress notes, lesson priorities — all in one place. My students could finally see exactly how far they had come.',
  },
  {
    initials: 'SR',
    name: 'S.R.',
    role: 'BJJ Instructor — Dublin, Ireland',
    text: 'The drills and training games were a complete revelation. My students talk about those sessions for weeks. They feel like a real experience — not just another block of repetitive technical training.',
  },
]
